/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id      : 'home',
        title   : 'Home',
        subtitle: '',
        type    : 'basic',
        icon    : 'heroicons_outline:home',
        link : '/apps/file-manager',
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id      : 'home',
        title   : 'Home',
        subtitle: '',
        type    : 'basic',
        icon    : 'heroicons_outline:home',
        link : '/apps/file-manager',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id      : 'home',
        title   : 'Home',
        subtitle: '',
        type    : 'basic',
        icon    : 'heroicons_outline:home',
        link : '/apps/file-manager',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id      : 'home',
        title   : 'Home',
        subtitle: '',
        type    : 'basic',
        icon    : 'heroicons_outline:home',
        link : '/apps/file-manager',
    },
    /*
    {
        id      : 'apps',
        title   : 'Views',
        subtitle: '',
        type    : 'group',
        icon    : 'heroicons_outline:bars-arrow-down',
        children: [
            {
                id   : 'apps.file-manager',
                title: 'File Manager',
                type : 'basic',
                icon : 'heroicons_outline:cloud',
                link : '/apps/file-manager',
            },
            {
                id      : 'apps.help-center',
                title   : 'Help Center',
                type    : 'collapsable',
                icon    : 'heroicons_outline:information-circle',
                link    : '/apps/help-center',
                children: [
                    {
                        id        : 'apps.help-center.home',
                        title     : 'Home',
                        type      : 'basic',
                        link      : '/apps/help-center',
                        exactMatch: true,
                    },
                    {
                        id   : 'apps.help-center.faqs',
                        title: 'FAQs',
                        type : 'basic',
                        link : '/apps/help-center/faqs',
                    },
                    {
                        id   : 'apps.help-center.guides',
                        title: 'Guides',
                        type : 'basic',
                        link : '/apps/help-center/guides',
                    },
                    {
                        id   : 'apps.help-center.support',
                        title: 'Support',
                        type : 'basic',
                        link : '/apps/help-center/support',
                    },
                ],
            },
            {
                id   : 'pages.profile',
                title: 'Profile',
                type : 'basic',
                icon : 'heroicons_outline:user-circle',
                link : '/pages/profile',
            },
            {
                id   : 'pages.settings',
                title: 'Settings',
                type : 'basic',
                icon : 'heroicons_outline:cog-8-tooth',
                link : '/pages/settings',
            }
        ],
    }
    */
];
